import React from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "shards-react";

import PageTitle from "../components/common/PageTitle";
import SmallStats from "../components/common/SmallStats";
import UsersOverview from "../components/blog/UsersOverview";
import CovidPieChart from "../components/blog/CovidPieChart";

class CovidOverView extends React.Component {
  constructor (props) {
    super(props);
    this.state ={
      covidData: [
        {
          label: "Total Confirmed",
          value: "",
          increase: true,
          // chartLabels: [],
          attrs: { md: "6", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "",
              borderWidth: 1.5,
              backgroundColor: "rgba(0, 184, 216, 0.1)",
              borderColor: "rgb(0, 184, 216)",
              data: [1, 3, 4, 5 ,6 , 8, 9]
            }
          ]
        },
        {
          label: "Active",
          value: "",
          percentage: "12.4",
          increase: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "6", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(23,198,113,0.1)",
              borderColor: "rgb(23,198,113)",
              data: [1, 3, 4, 5 ,6 , 8, 9]
            }
          ]
        },
        
        
        {
          label: "Recovered",
          value: "",
          percentage: "2.4%",
          increase: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "4", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgb(0,123,255,0.1)",
              borderColor: "rgb(0,123,255)",
              data: [3, 4, 5 ,6, 7, 9, 7]
            }
          ]
        },
        {
          label: "Deaths",
          value: "29",
          // percentage: "2.71%",
          increase: true,
          chartLabels: [null, null, null, null, null, null, null],
          attrs: { md: "4", sm: "6" },
          datasets: [
            {
              label: "Today",
              fill: "start",
              borderWidth: 1.5,
              backgroundColor: "rgba(255,65,105,0.1)",
              borderColor: "rgb(255,65,105)",
              data: [1, 2, 3, 4, 5, 8, 9, 8]
            }
          ]
        }
      ]
    };
  }

  componentDidMount() {
    var index = 0,
      dailyConfirmedCovidData =[8, 10, 11],
      dailyActiveCovidData =[],
      dailyRecoveredCovidData =[],
      dailyDeathsCovidData = [];
    fetch("https://data.covid19india.org/data.json")
    .then((res) => res.json())
    .then((data) => {
      for (index = 0; index < data.cases_time_series.length; index++) {
        dailyConfirmedCovidData.push(parseInt(data.cases_time_series[index].totalconfirmed));
        dailyActiveCovidData.push(parseInt(data.cases_time_series[index].dailyconfirmed));
        dailyDeathsCovidData.push(parseInt(data.cases_time_series[index].totaldeceased));
        dailyRecoveredCovidData.push(parseInt(data.cases_time_series[index].totalrecovered));
      }
      this.setState({
        dailyActiveCovidData: dailyActiveCovidData.slice(Math.max(dailyActiveCovidData.length - 5, 0)),
        dailyConfirmedCovidData,
        dailyDeathsCovidData,
        dailyRecoveredCovidData
      });
      this.setState({
        covidData: [
          {
            label: "Total Confirmed",
            value: data.statewise[0].confirmed,
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "6", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(0, 184, 216, 0.1)",
                borderColor: "rgb(0, 184, 216)",
                data: dailyConfirmedCovidData.slice(Math.max(dailyConfirmedCovidData.length - 5, 0))
              }
            ]
          },
          {
            label: "Active",
            value: data.statewise[0].active,
            percentage: "12.4",
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "6", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(23,198,113,0.1)",
                borderColor: "rgb(23,198,113)",
                data: dailyActiveCovidData.slice(Math.max(dailyActiveCovidData.length - 5, 0))
              }
            ]
          },
          
          
          {
            label: "Recovered",
            value: data.statewise[0].recovered,
            percentage: "2.4%",
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "4", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgb(0,123,255,0.1)",
                borderColor: "rgb(0,123,255)",
                data: dailyRecoveredCovidData.slice(Math.max(dailyRecoveredCovidData.length - 5, 0))
              }
            ]
          },
          {
            label: "Deaths",
            value: data.statewise[0].deaths,
            // percentage: "2.71%",
            increase: true,
            chartLabels: [null, null, null, null, null, null, null],
            attrs: { md: "4", sm: "6" },
            datasets: [
              {
                label: "Today",
                fill: "start",
                borderWidth: 1.5,
                backgroundColor: "rgba(255,65,105,0.1)",
                borderColor: "rgb(255,65,105)",
                data: dailyDeathsCovidData.slice(Math.max(dailyDeathsCovidData.length - 5, 0))
              }
            ]
          }
        ]
      });
    })
    .catch(console.log);
  }

render () {
  return (
  <Container fluid className="main-content-container px-4">
    {/* Page Header */}
    <Row noGutters className="page-header py-4">
      <PageTitle title="Overall Stats" subtitle="COVID-19 Tracker | INDIA" className="text-sm-left mb-3" />
    </Row>

    {/* Small Stats Blocks */}
    <Row>
      {this.state.covidData.map((stats, idx) => (
        <Col className="col-lg mb-4" key={idx} {...stats.attrs}>
          <SmallStats
            id={`small-stats-${idx}`}
            variation="1"
            chartData={stats.datasets}
            chartLabels={stats.chartLabels}
            label={stats.label}
            value={stats.value}
          />
        </Col>
      ))}
    </Row>

    <Row>
      {/* Users Overview */}
      <Col lg="8" md="12" sm="12" className="mb-4">
        <UsersOverview />
      </Col>

      {/* Users by Device */}
      <Col lg="4" md="6" sm="12" className="mb-4">
        <CovidPieChart />
      </Col>
    </Row>
  </Container>
  );
      }
 
}

export default CovidOverView;
